import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { AnimatePresence } from 'framer-motion'
import Layout from './components/Layout'
import Home from './routes/Home'
import Episodes from './routes/Episodes'
import EpisodeDetail from './routes/EpisodeDetail'
import About from './routes/About'
import Guests from './routes/Guests'
import Subscribe from './routes/Subscribe'
import Contact from './routes/Contact'
import Admin from './routes/Admin'
import PromptIdeas from './routes/PromptIdeas'
import BlogListing from './routes/BlogListing'
import BlogPost from './routes/BlogPost'
import BlogEditor from './routes/BlogEditor'
import ProtectedRoute from './components/LaunchGate'
import NotFound from './routes/NotFound'

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Layout>
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/episodes" element={<Episodes />} />
              <Route path="/episodes/:slug" element={<EpisodeDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/guests" element={<Guests />} />
              <Route path="/subscribe" element={<Subscribe />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
              <Route path="/prompt-ideas" element={<ProtectedRoute><PromptIdeas /></ProtectedRoute>} />
              <Route path="/blog" element={<BlogListing />} />
              <Route path="/blog/editor" element={<ProtectedRoute><BlogEditor /></ProtectedRoute>} />
              <Route path="/blog/editor/:slug" element={<ProtectedRoute><BlogEditor /></ProtectedRoute>} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AnimatePresence>
        </Layout>
      </Router>
    </HelmetProvider>
  )
}

export default App
